var _excluded = ["openModalType", "onSignUpSuccess", "onLogInSuccess"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import MembershipModal from "@xo-union/tk-component-membership-modal";
import MembershipFormRedux from "@xo-union/tk-ui-membership-form-redux";
var MembershipModalReduxWrapper = function MembershipModalReduxWrapper(_ref) {
  var openModalType = _ref.openModalType,
    onSignUpSuccess = _ref.onSignUpSuccess,
    onLogInSuccess = _ref.onLogInSuccess,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MembershipModal, _extends({}, props, {
    openModal: openModalType,
    renderMembershipForm: function renderMembershipForm(formProps) {
      return /*#__PURE__*/React.createElement(MembershipFormRedux, _extends({
        onSignUpSuccess: onSignUpSuccess,
        onLogInSuccess: onLogInSuccess
      }, formProps));
    }
  }));
};
process.env.NODE_ENV !== "production" ? MembershipModalReduxWrapper.propTypes = {
  openModalType: PropTypes.oneOf(['LOG_IN', 'SIGN_UP']),
  onSignUpSuccess: PropTypes.func.isRequired,
  onLogInSuccess: PropTypes.func.isRequired
} : void 0;
MembershipModalReduxWrapper.defaultProps = {
  openModalType: null
};
export default MembershipModalReduxWrapper;